import { createElementFromHtml } from "./create-element";

const $ = jQuery;

export interface ToastData {
  politeness: 'off' | 'polite' | 'assertive',
  autohide: boolean,
  delay: number,
  animation: boolean,
  titleHtml?: string,
  titleText?: string,
  contentHtml?: string,
  contentText?: string,
  imageUrl?: string,
  imageHtml?: string,
  imageClasses: string[],
  dismissable: boolean,
}

export function showToast( args: Partial<ToastData> ) {

  const defaultData: ToastData = {
    politeness: 'assertive',
    autohide: true,
    delay: 2000,
    animation: true,
    titleHtml: undefined,
    titleText: undefined,
    contentHtml: undefined,
    contentText: undefined,
    imageUrl: undefined,
    imageHtml: undefined,
    imageClasses: [ 'rounded', 'mr-2' ],
    dismissable: true,
  };

  const data = {
    ...defaultData,
    ...args,
  }

  let toaster: HTMLElement | null = document.getElementById( 'toaster' );

  if ( !toaster ) {
    toaster = <div id="toaster" aria-live="polite" aria-atomic="true"></div>;
    document.body.appendChild( toaster );
  }

  const toast = <div className="toast" role="alert" aria-atomic="true"></div>;
  const toastHeader = <div className="toast-header"></div>;
  const toastBody = <div className="toast-body"></div>;

  toast.setAttribute( 'aria-live', data.politeness );

  toast.dataset.autohide = data.autohide ? 'true' : 'false';
  toast.dataset.animation = data.animation ? 'true' : 'false';
  toast.dataset.delay = data.delay.toString();

  if ( data.imageHtml || data.imageUrl ) {
    let image: HTMLImageElement;
    if ( data.imageHtml ) {
      image = createElementFromHtml<HTMLImageElement>( data.imageHtml );
    } else if ( data.imageUrl ) {
      image = <img src="about:blank" alt="" /> as any as HTMLImageElement;
      image.src = data.imageUrl;
    }
    if ( image! ) {
      image.classList!.add( 'rounded', 'mr-2' );
      toastHeader.insertAdjacentElement( 'beforeend', image );
    }
  }

  if ( data.titleHtml || data.titleText ) {
    let title: HTMLElement;
    if ( data.titleHtml ) {
      title = createElementFromHtml( data.titleHtml );
    } else if ( data.titleText ) {
      title = <strong className="mr-auto"></strong>;
      title.insertAdjacentText( 'beforeend', data.titleText );
    }
    if ( title! ) {
      toastHeader.insertAdjacentElement( 'beforeend', title );
    }
  }

  if ( data.dismissable ) {
    const closeButton = <button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close"><span aria-hidden="true">&times;</span></button>;
    toastHeader.insertAdjacentElement( 'beforeend', closeButton );
  }

  if ( data.contentHtml ) {
    toastBody.insertAdjacentHTML( 'beforeend', data.contentHtml );
  } else if ( data.contentText ) {
    toastBody.insertAdjacentText( 'beforeend', data.contentText );
  }

  if ( toastHeader.childElementCount ) {
    toast.append( toastHeader );
  }

  if ( toastBody.childElementCount ) {
    toast.append( toastBody );
  }

  toaster.append( toast );

  $( toast ).toast( 'show' );

}
